<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#2bb8c0" type="square-jelly-box">
    <p style="color: #80b941"> Loading... </p>
</ngx-spinner>
<router-outlet></router-outlet>